<template>
    <div id="block">
        <div class="slides">
            <div class="slide slide-hero current">
                <Hero class="slide-inner" :bus="bus" ref="slide0"/>
                <div class="transition-layer"></div>
            </div>
            <div v-for="(slide, index) in slideData" class="slide" v-on:click="viewDetail(index)" :key="index">
                <Slide :title="slide.title" :bus="bus" :index="index + 1" class="slide-inner"/>
            </div>

        </div>
        <BlockIndicator :slide-count="slideCount" :current-slide="currentSlide" :slide-data="slideData" ref="indicator"></BlockIndicator>
        <DetailPage :current-slide="currentSlide" ref="detailPage"></DetailPage>
    </div>
</template>

<script>
import BlockIndicator from "@/components/BlockIndicator.vue";
import Hero from "@/pages/Hero.vue";
import Slide from "@/pages/Slide.vue";
import DetailPage from "@/components/DetailPage.vue";
import Vue from "vue";

export default {
    name: "block",
    components: {
        BlockIndicator,
        Hero,
        Slide,
        DetailPage
    },
    data: function() {
        return {
            bus: new Vue(),
            currentSlide: 0,
            slideCount: 0,
            animating: false,
            viewing: false,
            about: false,
            slideData: [
                {
                    title: "Necessity"
                },
                {
                    title: "Leadership"
                },
                {
                    title: "Creativity"
                },
                {
                    title: "Intent"
                },
                {
                    title: "Diversity"
                },
                {
                    title: "Culture"
                }
            ]
        };
    },
    mounted: function() {
        this.slideCount = this.$el.querySelectorAll(".slide").length - 1;

        const positionY = this.$el.offsetTop;
        const viewportHeight = this.$el.querySelector(".slide:first-of-type")
            .offsetHeight;
        const contentHeight = document.body.scrollHeight;
        const maxScroll = contentHeight - viewportHeight;

        this.$store.subscribe((mutation, state) => {
            let wheelDirection = state.wheelDirection;

            if (
                !this.animating &&
                !this.viewing &&
                !this.about &&
                mutation.type == "wheel"
            ) {
                if (wheelDirection == "up") {
                    if (this.currentSlide > 0) {
                        this.animating = true;

                        if (this.currentSlide == 1) {
                            this.$el
                                .querySelector(".transition-layer")
                                .classList.remove("do");
                            document
                                .querySelector("nav")
                                .classList.remove("white");
                            document
                                .querySelector(".symbol")
                                .classList.add("hide");
                            document
                                .querySelector(".logo")
                                .classList.remove("hide");
                            document
                                .querySelector(".blockIndicator")
                                .classList.remove("show");
                        }

                        this.bus.$emit("transition-exit", this.currentSlide);
                        this.bus.$emit(
                            "transition-enter",
                            this.currentSlide - 1
                        );

                        let promise = new Promise(this.exitAnimation);
                        promise.then(
                            this.enterAnimation(--this.currentSlide + 1)
                        );
                    }
                } else if (wheelDirection == "down") {
                    if (this.currentSlide < this.slideCount) {
                        this.animating = true;

                        this.$el
                            .querySelector(".transition-layer")
                            .classList.add("do");
                        document.querySelector("nav").classList.add("white");
                        document
                            .querySelector(".symbol")
                            .classList.remove("hide");
                        document.querySelector(".logo").classList.add("hide");
                        document
                            .querySelector(".blockIndicator")
                            .classList.add("show");

                        this.bus.$emit("transition-exit", this.currentSlide);
                        this.bus.$emit(
                            "transition-enter",
                            this.currentSlide + 1
                        );

                        let promise = new Promise(this.exitAnimation);
                        promise.then(
                            this.enterAnimation(++this.currentSlide + 1)
                        );
                    }
                }
            }
        });

        this.initCarouselTitle();
        this.initStaggerText();

        setTimeout(() => {
            this.$el
                .querySelector(".slide-hero .stagger")
                .classList.add("show");
            this.$el.querySelector(".slide-hero .fadein").classList.add("show");
            this.$el
                .querySelector(".slide-hero .scroll-help")
                .classList.add("show");
        }, 100);

        this.$refs.detailPage.$on("close", this.closeDetail);
        this.$refs.indicator.$on("switch", this.switchSlide);

        this.$store.subscribe((mutation, state) => {
            if (mutation.type == "disableWheel") {
                if (state.isWheelDisabled) {
                    this.about = true;
                    document.querySelector("nav").classList.add("white");
                    document.querySelector(".symbol").classList.add("hide");
                    document.querySelector(".logo").classList.add("hide");
                    document
                        .querySelector(".logo-white")
                        .classList.remove("hide");
                    document
                        .querySelector("header")
                        .classList.remove("difference");
                    document
                        .querySelector("nav")
                        .classList.remove("difference");
                } else {
                    this.about = false;

                    if (this.currentSlide == 0) {
                        document.querySelector("nav").classList.remove("white");
                        document
                            .querySelector(".logo")
                            .classList.remove("hide");
                        document
                            .querySelector(".logo-white")
                            .classList.add("hide");
                    } else {
                        document
                            .querySelector(".symbol")
                            .classList.remove("hide");
                        document
                            .querySelector(".logo-white")
                            .classList.add("hide");
                    }

                    if (this.viewing) {
                        document
                            .querySelector("header")
                            .classList.add("difference");
                        document
                            .querySelector("nav")
                            .classList.add("difference");
                    }
                }
            }

            if (mutation.type == "toHome") {
                this.animating = true;

                if (this.viewing) {
                    this.$refs.detailPage.close();
                    this.closeDetail();
                }

                this.$el
                    .querySelector(".transition-layer")
                    .classList.remove("do");
                document.querySelector("nav").classList.remove("white");
                document.querySelector(".symbol").classList.add("hide");
                document.querySelector(".logo").classList.remove("hide");
                document
                    .querySelector(".blockIndicator")
                    .classList.remove("show");

                this.bus.$emit("transition-exit", this.currentSlide);
                this.bus.$emit("transition-enter", 0);

                let promise = new Promise(this.exitAnimation);
                promise.then(this.enterAnimation(1));

                this.currentSlide = 0;
            }
        });
    },
    methods: {
        viewDetail: function(page) {
            this.viewing = true;
            this.$refs.detailPage.show();
            document.querySelector("header").classList.add("difference");
            document.querySelector("nav").classList.add("difference");
        },
        closeDetail: function() {
            this.viewing = false;
            document.querySelector("header").classList.remove("difference");
            document.querySelector("nav").classList.remove("difference");
        },
        exitAnimation: function(resolve, reject) {
            this.$el
                .querySelector(".slide.current")
                .classList.remove("current");

            resolve();
        },
        enterAnimation: function(nextSlide) {
            this.$el
                .querySelector(".slide:nth-of-type(" + nextSlide + ")")
                .classList.add("current");

            setTimeout(() => {
                this.animating = false;
            }, 2000);
        },
        initCarouselTitle: function() {
            let titles = this.$el.querySelectorAll(".carousel-title");

            titles.forEach(title => {
                let letters = title.innerText.split("");
                title.innerHTML = "";

                letters.forEach(letter => {
                    let wrapper = document.createElement("div");
                    wrapper.classList.add("wrapper");
                    let div = document.createElement("div");
                    div.classList.add("letter");
                    div.innerText = letter;

                    wrapper.appendChild(div);
                    title.appendChild(wrapper);
                });
            });
        },
        initStaggerText: function() {
            let textGroup = this.$el.querySelectorAll(".stagger");

            textGroup.forEach(text => {
                let words = text.innerText.split(" ");
                text.innerText = "";

                words.forEach(word => {
                    let wordWrapper = document.createElement("div");
                    wordWrapper.classList.add("word");

                    let letters = word.split("");

                    letters.forEach(letter => {
                        let div = document.createElement("div");
                        div.classList.add("letter");
                        div.innerHTML = letter == " " ? "&nbsp;" : letter;

                        wordWrapper.appendChild(div);
                    });

                    let space = document.createElement("div");
                    space.classList.add("letter");
                    space.innerHTML = "&nbsp;";
                    wordWrapper.appendChild(space);
                    text.appendChild(wordWrapper);
                });
            });
        },
        switchSlide: function(index) {
            if (this.currentSlide != index && !this.animating) {
                this.animating = true;

                if (this.viewing) {
                    this.$refs.detailPage.close();
                    this.closeDetail();
                }

                this.$el.querySelector(".transition-layer").classList.add("do");
                document.querySelector("nav").classList.add("white");
                document.querySelector(".symbol").classList.remove("hide");
                document.querySelector(".logo").classList.add("hide");
                document.querySelector(".blockIndicator").classList.add("show");

                this.bus.$emit("transition-exit", this.currentSlide);
                this.bus.$emit("transition-enter", index);

                let promise = new Promise(this.exitAnimation);
                promise.then(this.enterAnimation(index + 1));
                this.currentSlide = index;
            }
        }
    }
};
// interact with user scroll to toggle through parts
// notify indicator on change
// show detail page and change router
</script>

<style lang="scss">
#block {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;

    @media ($mobile-screen) {
        position: fixed;
    }
}

.area-view {
    width: 500px;
    height: 500px;
}

.slides {
    overflow: hidden;
    width: 100%;
    height: 100vh;
}

.slide {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    overflow: hidden;

    &.current {
        pointer-events: all;

        .title {
            opacity: 1;
        }

        .cursor-view {
            transform: translate3d(0, 0, 0);
        }
    }
}

.cursor-view {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 6;
    cursor: none;

    @media ($device-screen) {
        pointer-events: none;
    }
}

.transition-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    pointer-events: none;

    &:before {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: #333333;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate3d(0, 100vh, 0);
        transition: transform 0.85s $custom-ease-2 0.25s;
    }

    &:after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background-color: black;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate3d(0, 100vh, 0);
        transition: transform 0.85s $custom-ease-2;
    }

    &.do {
        &:before {
            transform: translate3d(0, 0, 0);
            transition: transform 0.85s $custom-ease-2;
        }

        &:after {
            transform: translate3d(0, 0, 0);
            transition: transform 0.85s $custom-ease-2 0.25s;
        }
    }
}

.stagger {
    .word {
        display: inline-block;
    }

    .letter {
        display: inline-block;
        transform: translate3d(0, 0, 0);
        opacity: 0;

        @for $i from 1 through 50 {
            &:nth-of-type(#{$i}) {
                transition: all 1s $primary-ease random(10) * 0.05s;
            }
        }
    }

    &.show {
        .letter {
            transform: translate3d(0, 0, 0);
            opacity: 1;
        }
    }
}

.fadein {
    opacity: 0;
    transition: opacity 0.65s $primary-ease 0.8s;

    &.show {
        opacity: 1;
    }
}
</style>
